var React = require('react');

function Gm (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0-48h640v480H0z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(0 48)","key":1},[React.createElement("path",{"fill":"red","d":"M0-128h640V85.3H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 85.3h640V121H0z","key":1}),React.createElement("path",{"fill":"#009","d":"M0 120.9h640V263H0z","key":2}),React.createElement("path",{"fill":"#fff","d":"M0 263.1h640v35.6H0z","key":3}),React.createElement("path",{"fill":"#090","d":"M0 298.7h640V512H0z","key":4})])]);
}

Gm.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gm;

Gm.default = Gm;
